import React, { Component } from 'react';
import { connect } from 'react-redux';
import { BrowserRouter, Switch, Route, Redirect, withRouter } from 'react-router-dom';
import $ from 'jquery';
import config from './config';
import common from './common';
import myConfigRoutes from './route-component';
import ScrollToTopOnMount from './components/ScrollToTopOnMount';
import { FadeIn } from './components/fadeIn';
import {
    resetTeamData,
} from './actions/ManageTeamActions';
import MainHeader from './components/MainHeader';
import Menu from './components/Menu';
import {
    setGamingHubStatus
} from './actions/AuthActions';

const COOKIE_GM = config.COOKIE_GM;
const doDefaultNavigation = (DefaultComponent, path, routeObject, props) => {
    let cookie = common.getCookie(COOKIE_GM);
    const headerElem = $('.si-ucl--head-wrap');
    let cookieGM = common.parseCookie(cookie);

    if (routeObject.path == "*") {
        //check for which location the user should land on and redirect
        // setLocation(routeObject.path);
        return (<Redirect to={ ('/create-team') } />);
    }

    let teamData = common.getLocalStorage(config.teamDataLocalStorageName)
    if (cookie) {
        if (routeObject.group == 'home') {
            let leagueInvObj = common.getLocalStorage('leagueInvObj');
            if (leagueInvObj) {
                return (<Redirect to={ ('/leagues') } replace />);
            }
        }

        if (routeObject.group === 'create-team') {
            if (common.isManageTeam()) {
                return (<Redirect to={ ('/') } replace />);
            }
        }

        if (routeObject.isTeamRequired && !common.isManageTeam()) {
            if (common.isEndOfSeason(props.constraints.GamercardSubScenario) && window.location.href.indexOf("/end-of-season") == -1) {
                return (<Redirect to={ ('/end-of-season') } replace />)
            } else {
                return (<Redirect to={ ('/create-team') } replace />);
            }
        }
        if (!common.isManageTeam() && common.isEndOfSeason(props.constraints.GamercardSubScenario) && cookieGM.HasTeam == 1) {
            return (<Redirect to={ ('/create-team') } replace />);
        }

        if (cookieGM.HasTeam == 1 && window.location.href.indexOf("/end-of-season") > -1) {
            return (<Redirect to={ ('/create-team') } replace />);
        }




    } else if (routeObject.isAuthRequired === true) {
        if (common.isEndOfSeason(props.constraints.GamercardSubScenario)) {
            return (<Redirect to={ ('/end-of-season') } replace />)
        } else {
            // if (props.isGamingHubLoaded) {
            return (<Redirect to={ ('/create-team') } replace />);
            // }

            // return (<Redirect to={('/fantasy-landing')} replace />);
        }
    }


    if (routeObject.name.indexOf('landing') >= 0) {
        let landingNameArr = routeObject.name.split('-')
        let client = (landingNameArr && landingNameArr.length ? landingNameArr[0] : "fantasy")
        if (config.landingPageClients.findIndex((c) => { return (c == client) }) >= 0) {
            let visitObj = common.getLocalStorage('visitedLandingPage')
            let visitedLandingPage = (visitObj ? visitObj[client] : 0);
            if ((visitedLandingPage && visitedLandingPage >= 3) || (teamData && teamData.playerCount > 0)) {
                return (<Redirect to={ ('/create-team') } replace />);
            }
        }
    }

    if (!cookie && !routeObject.isAuthRequired && window.location.href.indexOf("/end-of-season") == -1) {
        if (common.isEndOfSeason(props.constraints.GamercardSubScenario)) {
            return (<Redirect to={ ('/end-of-season') } replace />)
        }
    }

    if (routeObject.group === 'home') {
        headerElem.removeClass('no-ad');
    } else {
        headerElem.addClass('no-ad');
    }




    let path__ = routeObject.path.indexOf(':') > -1 ? routeObject.path_ : routeObject.path;
    //check for end of season



    let hideHeader = false;
    if (cookie) {
        if (common.isEndOfSeason(props.constraints.GamercardSubScenario) && !cookieGM.HasTeam) {
            hideHeader = true;
        }
    } else {
        if (common.isEndOfSeason(props.constraints.GamercardSubScenario)) {
            hideHeader = true;
        }
    }

    if (window.pathName == path__) {
        //so that no page track get called multiple times
    } else {
        window.pathName = path__;
        common.pageViewTracking(path__, routeObject);
    }



    if (common.getLocalStorage("saveTeam") == true) {
        common.customTracking('Save Team (Already Logged in User)', '/uclfantasy/save-team/');
        common.customTracking('Team created successfully', '/uclfantasy/save-team/');
        common.setLocalStorage("saveTeam", false)
    }
    if (props.trans[`title_${routeObject.name}`]) {
        document.title = props.trans[`title_${routeObject.name}`];
    }
    else {
        if (routeObject.group == 'landing') {
            document.title = "Landing"
        }
    }

    const SomeComponent = withRouter(props => {
        const Elem = FadeIn(DefaultComponent, 0.5);
        return <React.Fragment>
            <ScrollToTopOnMount />
            <Menu hideHeader={ hideHeader } />
            <Elem { ...props } />
        </React.Fragment>
    });
    return <SomeComponent />
};

class Routes extends Component {

    constructor(props) {
        super(props);


    }

    componentWillMount() {
        this.props.gamingHubLoaded(false);

        if (window.console.log) { window.console.log = function () { } }
        window.initialLoaded = true;
        window.menuPreviousPage = ''
    }

    componentDidMount() {
        // common.setLocalStorage("isAdBlocked", common.detectAdBlocker());

    }



    render() {
        let { initialLoginCompleted, trans, constraints, isGamingHubLoaded } = this.props;
        const myRoutes = myConfigRoutes.map((el, index) => {
            let component = el.component;
            let path = el.path;
            if (path === '/') {
                return <Route exact key={ index } path={ path }
                    render={ () => doDefaultNavigation(component, path, el, this.props) } />
            }
            return <Route key={ index } path={ path }
                render={ () => doDefaultNavigation(component, path, el, this.props) } />
        });


        if (window.location.href.indexOf("index.html") > -1) {
            return <React.Fragment>
                <MainHeader trans={ trans } />
                <BrowserRouter basename={ "/en/uclfantasy/static/index.html?" }>
                    <Switch>
                        { myRoutes }
                    </Switch>
                </BrowserRouter>
            </React.Fragment>
        } else if (window.location.href.indexOf("index-ghc.html") > -1) {
            return <React.Fragment>
                <MainHeader trans={ trans } />
                <BrowserRouter basename={ "/en/uclfantasy/static/index-ghc.html?" }>
                    <Switch>
                        { myRoutes }
                    </Switch>
                </BrowserRouter>
            </React.Fragment>
        } else {

            return <React.Fragment>
                <MainHeader trans={ trans } />
                { initialLoginCompleted && isGamingHubLoaded ? <BrowserRouter basename={ config.BASE_DIR }>
                    <Switch>
                        { myRoutes }
                    </Switch>
                </BrowserRouter> : (<div className="si-loader-wrap" id="loader">
                    <div className="si-loader">
                        <div></div>
                        <div></div>
                        <div></div>
                        <div></div>
                        <div></div>
                        <div></div>
                        <div></div>
                        <div></div>
                        <div></div>
                        <div></div>
                    </div>
                </div>) }
            </React.Fragment>
        }







    };
}

const mapStateToProps = (state) => {
    return {
        trans: state.appData.trans,
        initialLoginCompleted: state.authData.initialLoginCompleted,
        isGamingHubLoaded: state.authData.isGamingHubLoaded,
        userToken: state.authData.userToken,
        constraints: state.appData.constraints,
    };
};
const mapDispatchToProps = (dispatch) => {
    return {
        resetTeamData: () => dispatch(resetTeamData()),
        gamingHubLoaded: (bool) => dispatch(setGamingHubStatus(bool))
    };
};
export default connect(mapStateToProps, mapDispatchToProps)(Routes);


// WEBPACK FOOTER //
// ./src/Routes.js